module.exports = __webpack_public_path__ + "static/media/step-mobile-2.789d26a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/how-it-works/stepper-how-it-works/step-mobile-2.png
// module id = 2215
// module chunks = 0